<template>
    <div class="authors-edit">
        <slot name="trigger" :open="open">
            <button
                v-t="'crm.authors.manager.add'"
                type="button"
                class="button button--blank"
                @click="open"
            />
        </slot>

        <portal to="modals">
            <Modal
                v-if="opened"
                :title="$t('crm.authors.manager.add')"
                name="authors-edit"
                modal-class="authors-edit__modal"
                @close="close"
            >
                <template #content>
                    <FormField
                        name="first_name"
                        :label="$t('misc.firstName')"
                        :required="requiredFields.includes('first_name')"
                        :label-width="labelWidth"
                    >
                        <FormInput
                            v-model="values.first_name"
                            required
                            :placeholder="$t('misc.firstName')"
                        />
                    </FormField>
                    <FormField
                        name="last_name"
                        :label="$t('misc.lastName')"
                        :required="requiredFields.includes('last_name')"
                        :label-width="labelWidth"
                    >
                        <FormInput v-model="values.last_name" :placeholder="$t('misc.lastName')" />
                    </FormField>
                    <FormField
                        name="description"
                        :label="$t('misc.description')"
                        :label-width="labelWidth"
                    >
                        <FormTextarea
                            v-model="values.description"
                            :placeholder="$t('misc.description')"
                            width="auto"
                        />
                    </FormField>
                </template>
                <template #bottom>
                    <button
                        v-t="'misc.save'"
                        type="button"
                        :disabled="!valid"
                        :class="['button', { 'is-disabled': !valid }]"
                        @click="save"
                    />
                </template>
            </Modal>
        </portal>
    </div>
</template>

<script>
import { makeid } from '@speechki-frontend/shared/helpers/functions';
import { Modal } from '@speechki-frontend/shared/ui/modals';
import { FormInput, FormField, FormTextarea } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'AuthorsEdit',
    components: {
        Modal,
        FormInput,
        FormField,
        FormTextarea,
    },
    data() {
        return {
            opened: false,
            values: undefined,
            initial: {
                first_name: null,
                last_name: null,
                description: null,
            },
            requiredFields: ['first_name'],
            labelWidth: '210px',
        };
    },
    computed: {
        valid() {
            return Object.keys(this.values)
                .filter((k) => this.requiredFields.includes(k))
                .every((k) => !!this.values[k]);
        },
    },
    created() {
        this.reset();
    },
    methods: {
        open() {
            this.opened = true;
            this.$emit('opened');
        },
        close() {
            this.opened = false;
            this.$emit('closed');
        },
        reset() {
            this.values = { ...this.initial };
        },
        save() {
            const data = {
                id: makeid(),
                ...this.values,
            };
            this.$emit('saved', data);
            this.reset();
            this.close();
        },
    },
};
</script>

<style lang="scss" src="./AuthorsEdit.scss"></style>
